import React from "react";
import {defaultBorderColor, NotifyModal} from "peggirkit";
import {useIntl} from "react-intl";
import {DayReportRefund} from "@/data/entities/dayReport";
import {globalConfirmModalProps} from "@/utils/ModalUtils";
import {twJoin} from "tailwind-merge";

type Props = {
    refund: DayReportRefund | null,
    onClose: () => void,
};

const CancellationInfoModal = ({refund, onClose}: Props) => {
    const intl = useIntl();

    return (
        <NotifyModal
            {...globalConfirmModalProps(intl)}
            show={refund !== null}
            onClose={onClose}
            title={intl.formatMessage({id: "cancellationReason"})}
            type={"info"}
            dismissButton={{
                text: intl.formatMessage({id: "close"}),
            }}
        >
            <p
                className={twJoin(
                    "text-black dark:text-white font-medium bg-gray-50 dark:bg-slate-700 border block p-3 rounded-lg",
                    defaultBorderColor,
                )}
            >
                {refund?.cancellationReason}
            </p>
        </NotifyModal>
    );
};

export default CancellationInfoModal;